
import {INTERVIEW_HISTORY_REQUEST, INTERVIEW_HISTORY_SUCCESS,INTERVIEW_HISTORY_FAIL} from "../constants/AuthConstant"


const axios = require("axios");
export const InterviewHistoryAction = (id,pageNumber) => {
    return function (dispatch) {
      dispatch({
        type: INTERVIEW_HISTORY_REQUEST,
        payload: true,
      });
     
      let OPTION = {
        
       url: `${process.env.REACT_APP_API_PATH}/ebench/interview/get_interview_scheduled_by_vendorId?vendorId=${id}&pageNumber=${pageNumber}&pageSize=10&flag=false`,
        method: "GET",
        headers: {
          "content-type": "application/json",
   
        },
      };
      axios(OPTION)
        .then((res) => {
            console.log(res.data,"hello");
          dispatch(loadAllDetailsPre(res.data));
        })
        .catch((error) => {
          dispatch({
            type: INTERVIEW_HISTORY_FAIL,
            payload: false,
            error: error,
            msg: "Failed to load the information",
          });
        });
    };
  };

  export const loadAllDetailsPre = (data) => {
    return {
      type: INTERVIEW_HISTORY_SUCCESS,
      result: data,
      payload: false,
      msg: "SUCCESS",
    };
  };